import { SnackbarProvider } from "notistack";
import { FC, ReactNode, useEffect } from "react";

import Snackbar from "~/components/ui/snackbar/Snackbar.tsx";
import { useAuth } from "~/contexts/AuthProvider";
import { ReditusHelmet } from "~/tracking/reditus";
import { useSegmentScript } from "~/tracking/segment";
import { FlashMessageListener } from "~/utils/flash";
import { saveRegistrationParamsToStorage } from "~/utils/registration/params";

import LoginHeader from "../../login/loginHeader/LoginHeader";
import styles from "./AuthContainer.module.scss";

type AuthContainerProps = {
  children: ReactNode;
};

const AuthContainer: FC<AuthContainerProps> = (props) => {
  const { segmentHelmet } = useSegmentScript();
  const { token } = useAuth();

  // Here a user is not authenticated. So we save specific query params to localStorage
  // Later they could be sent to server on user creation
  useEffect(() => {
    if (!token) {
      saveRegistrationParamsToStorage();
    }
  }, [token]);

  return (
    <div className={styles.page}>
      <SnackbarProvider
        maxSnack={9}
        Components={{
          error: Snackbar,
          success: Snackbar,
          warning: Snackbar,
          info: Snackbar,
          default: Snackbar,
        }}
        TransitionProps={{ direction: "left" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        autoHideDuration={5000}
      />
      <FlashMessageListener />
      {segmentHelmet}
      <ReditusHelmet />
      <LoginHeader />
      <div className={styles.pageBg}>
        <div className={styles.formWrapper}>
          <div className={styles.formContainer}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};
export default AuthContainer;
